let forms = {
	withdrawal: {
		icon: 'fa fa-user',
		title: 'Change Profile',
		subtitle: 'Change your profile details',
		forms: [
			{
				type: 'text',
				form_type: 'number',
				class: 'col-12',
				model: 'amount',
				validation: 'required|min:1|max:8',
				label: 'Amount',
			},
		],
	},
	statement: {
		icon: 'fa fa-user',
		title: 'Change Profile',
		subtitle: 'Change your profile details',
		forms: [
			{
				type: 'datepicker',
				form_type: 'date',
				format: 'dd-MM-yyyy',
				placement: 'bottom-end',
				placeholder: 'Select a date',
				model: 'from',
				label: 'From',
				class: 'col-12',
				validation: 'required',
			},
			{
				type: 'datepicker',
				form_type: 'date',
				format: 'dd-MM-yyyy',
				placement: 'bottom-end',
				placeholder: 'Select a date',
				model: 'to',
				label: 'To',
				class: 'col-12',
				validation: 'required',
			},
			// {
			//   type: 'radio', class: 'col-12 funkyradio', elClass: 'funkyradio', model: 'download_type', label: 'Statement Document', validation: 'required',
			//   options: [
			//       { val: 'download', label: 'Download' },
			//       { val: 'email', label: 'Send via email' },
			//     ], classes: { radioRow: 'row', radioCol: 'col-12 col-md-6' }
			// },
		],
	},
	declaration_form: {
		icon: 'fa fa-user',
		title: 'Change Profile',
		subtitle: 'Change your profile details',
		forms: [
			{
				type: 'checkbox',
				class: 'col-12 custom-check',
				model: 'declaration',
				validation: 'required',
				label: '<div class="small">I agree that the information provided is correct.</div>',
			},
		],
	},
};

module.exports = {
	name: 'Account Transactions',
	forms: utils.generateAllFormData(forms),
	table: {
		title: 'Transctions',
		subtitle: 'Transctions List',
		table_fields: [
			{ name: 'Tran Date', align: 'c' },
			{ name: 'Tran Ref', align: 'c' },
			{ name: 'Tran Amount', align: 'c' },
			{ name: 'Debit / Credit', align: 'c' },
			{ name: 'Remarks', align: 'c' },
		],
		searchFields: ['tran_ref', 'tran_amount', 'tran_type', 'remarks'],
		rowData: [
			{ type: 'date', field: 'tran_date', class: 'text-center' },
			{ type: 'text', field: 'tran_ref', class: ' text-center' },
			{ type: 'currency', field: 'tran_amount', class: 'text-center' },
			{ type: 'text', field: 'tran_type', class: 'text-center' },
			{ type: 'text', field: 'remarks', class: 'text-center' },
		],
	},
};
